import moment from 'moment'
import Vue from 'vue'

import App from './App'
import setupAxios from './plugins/axios'
// import setupD3 from './plugins/d3'
import setupVuetify from './plugins/vuetify'
import './registerServiceWorker'
import * as constants from './const'
import router from './router'
import store from './store'

moment.locale('ru')

setupAxios(Vue)
// setupD3(Vue)
const vuetify = setupVuetify(Vue)

Vue.config.productionTip = false

Vue.prototype.$const = Object.freeze(constants)

const app = new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')

if (process.env.NODE_ENV === 'development') { window._app = app }
